export default function LkProfile(){

    const body = document.querySelector('body');

    body.addEventListener('click', function (e) {
        let changeProfileButton = e.target.closest('[data-profile="change-data"]');
        if (!changeProfileButton) return;

        let surname = document.querySelector('[data-profile-text="surname"]');
        let name = document.querySelector('[data-profile-text="name"]');
        let phone = document.querySelector('[data-profile-text="phone"]');
        let date = document.querySelector('[data-profile-text="date"]');

        let surnameInput = document.querySelector('[data-profile-input="surname"]');
        let nameInput = document.querySelector('[data-profile-input="name"]');
        let phoneInput = document.querySelector('[data-profile-input="phone"]');
        let dateInput = document.querySelector('[data-profile-input="date"]');

        surnameInput.value = surname.innerHTML.trim();
        nameInput.value = name.innerHTML.trim();
        phoneInput.value = phone.innerHTML.replace(/\D/g,'').substring(1);
        dateInput.value = date.innerHTML.trim();
    });
}